import React from "react";
import NewEmail from "./NewEmail";
const ChangeEmail = ({ setPage }) => {
    return React.createElement(NewEmail, { backAction: () => setPage(1), setStep: setPage });
};
export default ChangeEmail;
